import template from './dijagnoza.html';
import {DijagnozaController} from './dijagnoza.controller.js';

const DijagnozaComponent = {
    restrict:'E',
    templateUrl: template,
    controller: DijagnozaController,
    controllerAs: 'vm'
};

export {DijagnozaComponent};



// WEBPACK FOOTER //
// ./app/components/dijagnoza/dijagnoza.component.js